// Traducciones en inglés para la política de privacidad
const privacy = {
  title: "Privacy Policy of Zaquiel Comic",
  lastUpdate: "Last updated: 26/12/2024",
  intro:
    "At Zaquiel Comic, we are committed to protecting our users' privacy and complying with the General Data Protection Regulation (GDPR). This privacy policy details how we collect, use, store, and protect your personal data. By using our website, you accept the terms of this policy.",
  responsible: {
    title: "1. Data Controller",
    description:
      "Data Controller: Carlos Ortega Muñoz\nAddress: C. del Padre Julio Chevalier, 2, 47012 Valladolid\nContact email: cortega27457@alumnos.uemc.es",
  },
  data: {
    title: "2. Collected Personal Data",
    description:
      "We collect the following personal data anonymously through our opinion form:",
    sex: "Sex",
    age: "Age",
    postalCode: "Postal Code (CP)",
    readingPreferences: "Reading preferences (digital or printed)",
    habits: "Reading habits and opinions about the comic",
    monumentResponses:
      "Responses related to the monument or place mentioned in the comic",
    comments: "Additional comments (optional)",
    noIdentification:
      "We do not collect information that can directly identify you, such as your name, email address, or IP address. Therefore, the stored data cannot be linked to a specific person.",
  },
  dataNotifications: {
    title: "2.1. Email Subscription for Notifications",
    description:
      "If you choose to subscribe to our email notifications, we will collect and store your email address to inform you about new chapters and content. These data are used exclusively for notification purposes and are not shared with third parties.",
  },
  purpose: {
    title: "3. Purpose of Data Processing",
    description:
      "Your data is collected and processed for the following purposes:",
    analyze:
      "To analyze readers' opinions about the comic and the associated monument/place.",
    improve: "To improve our content and user experiences.",
    statistics: "To conduct anonymous statistical studies.",
  },
  legalBasis: {
    title: "4. Legal Basis for Processing",
    description:
      "The processing of your data is based on your explicit consent, given when you accept our privacy policy by completing the form. You can withdraw your consent at any time (see Section 8).",
  },
  storage: {
    title: "5. Data Retention Period",
    description:
      "Your personal data will be stored for as long as necessary to fulfill the purposes described above. Once fulfilled, the data will be anonymized or periodically deleted.",
  },
  recipients: {
    title: "6. Data Recipients",
    description:
      "Your data will not be shared with third parties, except:",
    legal: "To comply with a legal obligation.",
    rights: "To protect our legal rights or prevent fraud.",
  },
  security: {
    title: "7. Data Security",
    description:
      "Although the collected data is anonymous, we implement appropriate technical and organizational measures to protect it against unauthorized access or misuse, including:",
    https: "Secure communications via HTTPS.",
    access: "Restricted access to data by authorized personnel.",
    deletion: "Periodic deletion of old data.",
  },
  rights: {
    title: "8. User Rights",
    description:
      "You have the right to withdraw your consent and make inquiries about the processing of your data. Since the data is anonymous, it cannot be linked to an individual for deletion.",
  },
  changes: {
    title: "9. Changes to the Privacy Policy",
    description:
      "We reserve the right to update this privacy policy at any time. Significant changes will be notified via a notice on our website.",
  },
  complaints: {
    title: "10. Complaints to the Competent Authority",
    description:
      "If you believe that your data is being processed in violation of the regulations, you have the right to file a complaint with the Spanish Data Protection Agency (AEPD) or the appropriate authority in your country.",
    link: "Link to the AEPD: https://www.aepd.es",
  },
}; 

export default privacy; 